/* eslint-disable @typescript-eslint/ban-ts-comment*/
/* eslint-disable prefer-const*/
/* eslint-disable @typescript-eslint/restrict-plus-operands*/
import React, { FC, useContext, useEffect, useRef, useState } from "react";
import _ from "lodash";
import MiniVideoCallControl from "./Components/video-call/mini-videocallcontrol"
import VideoCallControl from "./Components/video-call"
import MiniAudioCallControl from "./Components/audio-call/mini-callcontrol"
import AudioCallControl from "./Components/audio-call/index"
import { ConferenceContext } from ".";
import { setOnCall } from "../../app/userState/userStateSlice";
import { useAppDispatch } from "../../app/hooks";

export const SettingsContext = React.createContext<any | null>(null);
export const MediaSettingsContext = React.createContext<any | null>(null);

const globals = {
  //this settings is to keep consistent with the sdk until backend for the app is setup
  // maxVideoTrackCount is the tracks i can see excluding my own local video.so the use is actually seeing 3 videos when their own local video is included.
  maxVideoTrackCount: 5,
};
type LocalData = {
  streamId: string,

}

interface IProps {
  meetingStatus: string;
  roomName: string;
  customerName: string;
  setMeetingStatus(status: string): void;
}
const DMSMedia: FC<IProps> = ({ meetingStatus, roomName, customerName, setMeetingStatus }) => {


  // whenever i join the room, i will get my unique id and stream settings from webRTC.
  // So that whenever i did something i will inform other participants that this action belongs to me by sending my streamId.
  const [myLocalData, setMyLocalData] = useState<LocalData>();

  // this is my own name when i enter the room.
  const [streamName, setStreamName] = useState("");

  //const [waitingOrMeetingRoom, setWaitingOrMeetingRoom] = useState("");
  const [leftTheRoom, setLeftTheRoom] = useState(false);
  // { id: "", track:{} },
  const [participants, setParticipants] = useState<any[]>([]);
  const [allParticipants, setAllParticipants] = useState<any[]>([]);

  const dispatch = useAppDispatch();
  useEffect(() => {
    if (meetingStatus.includes("waiting") || meetingStatus.includes("meeting")) {
      setLeftTheRoom(false)
      dispatch(setOnCall("Incoming Video Call"));
    }

  }, [])

  return (
    meetingStatus === "waiting-video-dms" || meetingStatus === "waiting-audio-dms" ? (

      <MiniVideoCallControl
        meetingStatus={meetingStatus}
        streamName={streamName}
        handleStreamName={(name) => setStreamName(name)}
        handleChangeRoomStatus={(status) => {
          console.log("waitingOrMeetingRoom >handlechangeroomstatus", status)
          if (status.includes("waiting") || status.includes("meeting"))
            setMeetingStatus(status)
          else {
            setMeetingStatus(status)
            setLeftTheRoom(true)
          }
        }
        }
      ></MiniVideoCallControl>

    ) : (

      <>
        {(meetingStatus === "meeting-video-dms" || meetingStatus === "meeting-audio-dms") &&
          <VideoCallControl
            participants={participants}
            allParticipants={allParticipants}
            myLocalData={myLocalData}
            roomName={roomName}
            handleChangeRoomStatus={(status) => {
              console.log("waitingOrMeetingRoom >handlechangeroomstatus", status)
              if (status.includes("waiting") || status.includes("meeting"))
                setMeetingStatus(status)
              else {
                setMeetingStatus(status)
                setLeftTheRoom(true)
              }
            }
            }
          ></VideoCallControl>
        }
      </>
    )

  );
}

export default DMSMedia;
